/* eslint-disable import/prefer-default-export */

// Less costly for equality checking
// [] !== [] but EmptyArr === EmptyArr
export const emptyList = [];
